
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aprender/[sessionSlug]",
      function () {
        return require("private-next-pages/aprender/[sessionSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aprender/[sessionSlug]"])
      });
    }
  